export default {"src":"/_next/static/media/phone.e5ee4730.svg","height":13,"width":14};